<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 返回按钮 -->
    <div
      class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor"
      @click="$router.push('/waterCard/cardList')"
    >
      <i class="el-icon-arrow-left fw-600"></i>
      返回
    </div>

    <!-- 选择 -->
    <div class="flex mgt-30 mgb-50">
      <div
        :class="selectActive == v.id ? 'topselectActive' : 'topselect'"
        v-for="v in select"
        :key="v.id"
        @click="selectBtn(v)"
      >
        {{ v.name }}
      </div>
    </div>

    <!-- 导入 -->
    <div v-if="selectActive == 1">
      <div class="fw-600">批量导入卡</div>
      <div class="color409eff cursor mgt-30" @click="download">
        下载Excle示例
      </div>
      <div class="fw-600 mgt-30 mgb-30">导入Excel</div>
      <el-upload
        ref="upload"
        :action="'#'"
        :limit="1"
        :multiple="false"
        :auto-upload="false"
        accept=".xls,.xlsx"
        :file-list="fileList"
        :http-request="uploadFile"
        :on-change="fileChange"
        :on-exceed="handleExceed"
        :on-remove="handleRemove"
      >
        <el-button size="small" type="primary">文件浏览</el-button>
      </el-upload>
      <!-- <div class="mgt-15">
        <span class="mgr-10">水卡管理员</span>
        <el-select
          clearable
          v-model="downUser"
          placeholder="请选择水卡管理员"
          filterable
        >
          <el-option
            v-for="(v, i) in userArr"
            :key="i"
            :label="v.name"
            :value="v.id"
          ></el-option>
        </el-select>
      </div> -->

      <el-button
        type="primary"
        class="mgt-30"
        plain
        @click="$refs.upload.submit()"
        >确 定</el-button
      >
    </div>

    <!-- 手动新增 -->
    <div v-if="selectActive == 2">
      <el-form ref="form" :model="form" label-width="120px" :rules="rules">
        <el-form-item label="开通方式">
          <el-radio-group v-model="form.way" @change="groupChange">
            <el-radio label="批量"></el-radio>
            <el-radio label="单个"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="机器来源" prop="source">
          <el-select
            v-model="form.source"
            placeholder="请选择机器来源"
            @change="addChange"
          >
            <el-option
              v-for="v in sourceArr"
              :key="v.dictId"
              :label="v.dictName"
              :value="v.dictName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="归属企业" prop="qiye">
          <el-select
            v-model="form.qiye"
            placeholder="请选择归属企业"
            filterable
          >
            <el-option
              v-for="(v, i) in guishuList"
              :key="i"
              :label="v.companyName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <div v-if="form.way == '批量'">
          <el-form-item label="起始卡号" prop="startCard">
            <el-input
              v-model="form.startCard"
              placeholder="请输入起始卡号"
            ></el-input>
          </el-form-item>

          <el-form-item label="终止卡号" prop="endCard">
            <el-input
              v-model="form.endCard"
              placeholder="请输入终止卡号"
            ></el-input>
            <div class="colorred">说明：已创建的实体卡无法再次开卡</div>
          </el-form-item>
        </div>

        <el-form-item label="卡号" v-if="form.way == '单个'" prop="card">
          <el-input v-model="form.card" placeholder="请输入卡号"></el-input>
          <div class="colorred">说明：已创建的实体卡无法再次开卡</div>
        </el-form-item>
        <!-- <el-form-item label="水卡管理员">
          <el-select
            v-model="form.userId"
            placeholder="请选择水卡管理员"
            filterable
            clearable
          >
            <el-option
              v-for="(v, i) in userArr"
              :key="i"
              :label="v.name"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" plain @click="cardAdd('form')"
            >开 通</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";

export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      select: [
        { id: 1, name: "批量导表开卡" },
        { id: 2, name: "手动新增" },
      ],
      selectActive: 1,
      fileList: [], //导入的文件列表
      sourceArr: [],
      form: {
        way: "批量",
        startCard: "",
        endCard: "",
        card: "",
        qiye: "",
        source: "",
        userId: "",
      },
      guishuList: [],

      rules: {
        startCard: [
          { required: true, message: "请输入起始卡号", trigger: "blur" },
        ],
        qiye: [{ required: true, message: "请选择归属企业", trigger: "blur" }],
        source: [
          { required: true, message: "请选择机器来源", trigger: "blur" },
        ],
        endCard: [
          { required: true, message: "请输入终止卡号", trigger: "blur" },
        ],
        card: [{ required: true, message: "请输入卡号", trigger: "blur" }],
      },
      userArr: [],
      downUser: "",
    };
  },
  created() {
    this.getguishu();
    this.getsource();
    this.getUserPull();
  },
  methods: {
    getUserPull() {
      this.$api.waterCard.userPull().then((res) => {
        if (res.code === 200) {
          this.userArr = res.data.list;
        }
      });
    },

    selectBtn(v) {
      this.selectActive = v.id;
    },

    // 归属下拉
    getguishu() {
      this.$api.enterprise.enterpriseListPullNew().then((res) => {
        this.guishuList = res.data;
      });
    },

    getsource() {
      this.$api.dict.list({ dictName: "机器来源" }).then((res) => {
        if (res.code === 200) {
          const arr = res.data;
          this.sourceArr = [];
          arr.forEach((v) => {
            if (v.dictPid !== 0) {
              this.sourceArr.push(v);
            }
          });
        }
      });
    },

    // 导表模板下载
    download() {
      this.$api.waterCard.template().then((res) => {
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = URL.createObjectURL(res);
        link.setAttribute("download", "实物卡模板.xls");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },

    /* 自定义上传 */
    uploadFile(params) {
      // 通过 FormData 对象上传文件
      let formData = new FormData();
      formData.append("file", params.file);

      /* 在这里发请求就行了 */
      /* ------------------------------------ */
      this.$api.waterCard
        .upload({
          file: formData,
          userId: this.downUser ? this.downUser : null,
        })
        .then((res) => {
          if (res.code === 200) {
            //   this.addVisible = false;
            handleAlert("导入成功", "success");
          }
        });
      /* ------------------------------------ */

      // 成功失败都删除文件;
      this.fileList.splice(-1, 1);
    },
    /* 文件上传后的钩子  在此做校验 */
    fileChange(file, fileList) {
      this.file = file;
      // console.log(fileList);
      this.fileList = fileList;
      console.log(this.fileList, "已上传的");
      console.log(file, fileList, "第一个");
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (extension !== "xlsx" && extension !== "xls") {
        this.$message.warning("只能上传后缀是.xlsx和xls的文件");
        fileList.splice(-1, 1); //移除错误文件
        return;
      }
      // 文件大小校验
      const size = file.size / 1024 / 1024;
      if (size > 5) {
        this.$message.warning("文件大小不得超过5M");
        fileList.splice(-1, 1); //移除错误文件
        return;
      }
      this.fileName = file.name;
    },
    /* 超出个数 */
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    // 导入的文件删除
    handleRemove(file, fileList) {
      console.log(file, fileList, "删除");
    },

    groupChange() {
      this.form.source = "";
      this.form.qiye = "";
      this.form.startCard = "";
      this.form.endCard = "";
    },

    // ======手动开通
    cardAdd(name) {
      let that = this;
      this.$refs[name].validate((valid) => {
        if (valid) {
          handleConfirm(`确认开通吗？`, "info")
            .then(() => {
              if (that.form.way == "批量") {
                let companyName = "";
                let sourceId = "";
                this.guishuList.forEach((v) => {
                  if (v.id == this.form.qiye) {
                    companyName = v.companyName;
                  }
                });
                this.sourceArr.forEach((v) => {
                  if (v.dictName == this.form.source) {
                    sourceId = v.dictId;
                  }
                });
                this.$api.waterCard
                  .cardAdd({
                    startCardId: that.form.startCard,
                    endCardId: that.form.endCard,
                    companyId: this.form.qiye,
                    companyName: companyName,
                    sourceName: this.form.source,
                    sourceId: sourceId,
                    type: 0,
                    userId: this.form.userId ? this.form.userId : null,
                  })
                  .then((res) => {
                    if (res.code === 200) {
                      handleAlert("新增成功", "success");
                      that.form.startCard = "";
                      that.form.endCard = "";
                    }
                  });
              } else {
                let companyName = "";
                let sourceId = "";
                this.guishuList.forEach((v) => {
                  if (v.id == this.form.qiye) {
                    companyName = v.companyName;
                  }
                });
                this.sourceArr.forEach((v) => {
                  if (v.dictName == this.form.source) {
                    sourceId = v.dictId;
                  }
                });
                this.$api.waterCard
                  .cardAdd({
                    endCardId: that.form.card,
                    companyId: this.form.qiye,
                    companyName: companyName,
                    sourceName: this.form.source,
                    sourceId: sourceId,
                    type: 1,
                    userId: this.form.userId ? this.form.userId : null,
                  })
                  .then((res) => {
                    if (res.code === 200) {
                      handleAlert("新增成功", "success");
                      that.form.startCard = "";
                      that.form.endCard = "";
                    }
                  });
              }
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.topselect {
  width: 500px;
  height: 30px;
  background: var(--card-bg);
  text-align: center;
  line-height: 30px;
  cursor: pointer;
}
.topselectActive {
  width: 500px;
  height: 30px;
  background: var(--accent);
  color: #fff;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
}
.el-input,
.el-select {
  width: 300px !important;
}
</style>
